import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ sellThrough, beginDate, endDate }) => {
    return (
        <div id="taxSummaryReport">
            {
                sellThrough.length <= 0 ?
                    //If there's NO DATA to display
                    <NoDataMsg />
                    :
                    sellThrough.length > 0 &&
                    //If there's DATA
                    <React.Fragment>
                        {/* TRANSACTIONS */}
                        <div className="row m-0">
                            <div className="text-center list_header">
                                {beginDate ?
                                    <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                        {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                    : ""}
                            </div>
                        </div>

                        <div >
                            {
                                sellThrough.map((item, index) => {
                                    return (
                                        <div className="row m-0 mb-2 center_xs col-4-p-0 col-4-em-0" key={index}>
                                            <div className="col-lg-12 title_th">
                                                <h3 className="m-0"><strong>{item.brand}</strong></h3>
                                            </div>{/* row - Date */}

                                            <div className="row col-lg-12 mb-1">
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                                    <label>Sold Qty</label>
                                                    <h3 className="m-0 money size_1-3vmax">{item.soldQty}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">

                                                    <label className="sm_label">Ordered Qty</label>
                                                    <h3 className="m-0 grey-text size_1-3vmax">{item.purchasedQty}</h3>
                                                </div> {/* Column Orders */}

                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">

                                                    <label className="sm_label">Sell Through %</label>
                                                    <h3 className="m-0 grey-text size_1-3vmax">{item.sellThrough + "%"}</h3>
                                                </div> {/* Column Orders */}
                                            </div>
                                        </div>
                                    );
                                })
                            }

                        </div>
                        {/*</CardSimple>
                </div>*/}

                    </React.Fragment>
            }
        </div>
    );
};

export default Body;